import { render } from "./CustomContentList.vue?vue&type=template&id=6a8364cd&scoped=true"
import script from "./CustomContentList.vue?vue&type=script&lang=js"
export * from "./CustomContentList.vue?vue&type=script&lang=js"

import "./CustomContentList.vue?vue&type=style&index=0&id=6a8364cd&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8364cd"]])

export default __exports__